import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Tools.module.scss';

export const ToolsMainSection = () => (
  <WorkPageLayout
    isMain
    leftContent={
      <div className={styles.toolsLeftSection}>
        <span className={styles.toolsMain_1}>TransparenTerra’s</span>
        <span className={styles.toolsMain_2}>Tools</span>
        <span className={styles.toolsMain_3}>and</span>
        <span className={styles.toolsMain_4}>principles</span>
      </div>
    }
    rightContent={null}
  />
);
